module.exports = __webpack_public_path__ + "static/media/Old_Man.383821ec.png";